module.exports = "/assets/src/client/assets/payment-icons/mollie/googlepay.svg";